import { render, staticRenderFns } from "./DataValue.vue?vue&type=template&id=08a7464c&scoped=true&"
import script from "./DataValue.vue?vue&type=script&lang=js&"
export * from "./DataValue.vue?vue&type=script&lang=js&"
import style0 from "./DataValue.vue?vue&type=style&index=0&id=08a7464c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7464c",
  null
  
)

export default component.exports